import React from 'react';
import './Footer.css';

const Footer = ({ onNavigate, currentPage }) => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo">
                <div className="logo-icon">🎈</div>
                <div className="logo-text">
                  <h3>Wonder Eventzz</h3>
                  <p>Celebrate life!</p>
                </div>
              </div>
              <p className="footer-description">
                Your one-stop destination for all party planning needs. 
                We make your celebrations memorable with our professional 
                event planning services.
              </p>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#birthday">Birthday Parties</a></li>
              <li><a href="#decorations">Decorations</a></li>
              <li><a href="#festival">Festival Decorations</a></li>
              <li><a href="#corporate">Corporate Events</a></li>
              <li><a href="#occasions">Special Occasions</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><a href="#planning">Event Planning</a></li>
              <li><a href="#decoration">Decoration Services</a></li>
              <li><a href="#catering">Catering</a></li>
              <li><a href="#photography">Photography</a></li>
              <li><a href="#entertainment">Entertainment</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>Noida, UP, India</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <span>+91 9001971755</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <span>Support@wondereventzz.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Social Media & Newsletter */}
        <div className="footer-social">
          <div className="social-links">
            <h4>Follow Us</h4>
            <div className="social-icons">
              {/* <a href="#" className="social-link facebook" aria-label="Facebook" title="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07c0 5.01 3.66 9.16 8.44 9.93v-7.03H7.9v-2.9h2.54V9.41c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.62.77-1.62 1.56v1.87h2.76l-.44 2.9h-2.32V22c4.78-.77 8.44-4.92 8.44-9.93z"/></svg>
              </a> */}
              <a 
                href="https://www.instagram.com/wonder_event55?igsh=NHljZDkyZ3dteXFv" 
                className="social-link instagram" 
                aria-label="Instagram" 
                title="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm0 2a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H7zm5 3a5 5 0 110 10 5 5 0 010-10zm0 2.2a2.8 2.8 0 100 5.6 2.8 2.8 0 000-5.6zM18.5 6.5a1 1 0 110 2 1 1 0 010-2z"/></svg>
              </a>
              {/* <a href="#" className="social-link twitter" aria-label="Twitter" title="Twitter">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.27 4.27 0 001.87-2.36 8.55 8.55 0 01-2.71 1.04 4.26 4.26 0 00-7.32 3.89A12.1 12.1 0 013 5.15a4.25 4.25 0 001.32 5.68 4.23 4.23 0 01-1.93-.53v.05a4.26 4.26 0 003.42 4.17c-.46.13-.94.2-1.43.2-.35 0-.69-.03-1.02-.1a4.27 4.27 0 003.98 2.96A8.54 8.54 0 012 19.54a12.07 12.07 0 006.56 1.92c7.87 0 12.18-6.52 12.18-12.18 0-.19 0-.37-.01-.56A8.7 8.7 0 0022.46 6z"/></svg>
              </a>
              <a href="#" className="social-link youtube" aria-label="YouTube" title="YouTube">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M23.5 6.2a3 3 0 00-2.1-2.1C19.7 3.5 12 3.5 12 3.5s-7.7 0-9.4.6A3 3 0 00.5 6.2 31.9 31.9 0 000 12a31.9 31.9 0 00.5 5.8 3 3 0 002.1 2.1c1.7.6 9.4.6 9.4.6s7.7 0 9.4-.6a3 3 0 002.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.8 15.5v-7l6.2 3.5-6.2 3.5z"/></svg>
              </a> */}
              <a href="#" className="social-link whatsapp" aria-label="WhatsApp" title="WhatsApp">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M20.5 3.5A11 11 0 006.4 20.8L3 21l.3-3.4A11 11 0 1020.5 3.5zM12 5.7a6.3 6.3 0 00-6.3 6.3c0 1 .3 2 .7 2.8l-.8 2.8 2.9-.8a6.3 6.3 0 002.7.7 6.3 6.3 0 006.3-6.3A6.3 6.3 0 0012 5.7zm3.6 8.8c-.2.5-1 1-1.3 1.1-.3.1-.7.2-1.1.1-.3 0-.7-.1-1.1-.2-.3-.1-.8-.3-1.7-.8-1-.6-1.6-1.4-1.9-1.7-.2-.3-.5-.6-.6-1 0-.3 0-.6.1-.8.1-.2.3-.5.5-.8.2-.3.4-.4.6-.4.1 0 .3 0 .4.1.2.1.3.3.4.5.1.2.2.3.1.5 0 .1-.1.4-.2.5-.1.1-.2.3-.3.4-.1.1-.2.2-.1.4.1.2.5.9 1.1 1.4.8.7 1.4.9 1.6 1 .2.1.3.1.5 0 .1 0 .3 0 .5-.2.2-.2.7-.6.8-.8.1-.2.3-.2.5-.1.2.1.9.4 1.1.5.1.1.2.2.2.3 0 .2 0 .4-.1.6z"/></svg>
              </a>
            </div>
          </div>
          
          {/* <div className="newsletter">
            <h4>Subscribe to Newsletter</h4>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="newsletter-input"
              />
              <button className="newsletter-button">Subscribe</button>
            </div>
          </div> */}
        </div>
         {/* Build Identity 
       <div className="build-name">
         <div className="build-text">
          <h4>Built By : SSD-TECH-PROG</h4>
         <p>We Work as hard as you do</p>
         </div>
        </div> */}



        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2025 Wondereventzz. All rights reserved.</p>
            </div>
            {/* Build Identity  */}
       <div className="build-name">
         <div className="build-text">
          <h4>
            Built By : SSD-TECH-PROG_
            <a 
              href="mailto:ssdtechprog@gmail.com" 
              className="know-more-link"
              title="Know more about SSD-TECH-PROG"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
            </a>
          </h4>
          {/* <p>
            <a href="mailto:ssdtechprog@gmail.com" className="build-email">
              ssdtechprog@gmail.com
            </a>
          </p> */}
         </div>
        </div>
            <div className="footer-bottom-links">
              <a
              href="#privacy"
              className="footer-link"
              onClick={(e) => {
                e.preventDefault();
                onNavigate('#privacy');
              }}
              >Privacy Policy</a>
              <a 
              href="#terms"
              className="footer-link"
              onClick={(e) => {
                e.preventDefault();
                onNavigate('#terms');
              }}
              >Terms of Service</a>
              <a href="#cookies" className="footer-link">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
